import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback } from 'react';
import { useAppContext } from '../context/app';
export var SHIMMER_TYPE_SUFFIX = '_SHIMMER';
export default (function (rootType) {
  var _useAppContext = useAppContext(),
      _useAppContext2 = _slicedToArray(_useAppContext, 2),
      appApi = _useAppContext2[1];

  var appActions = appApi.actions;
  var setNextRootComponent = appActions.setNextRootComponent;
  var type = "".concat(rootType.toUpperCase()).concat(SHIMMER_TYPE_SUFFIX);
  var setShimmerType = useCallback(function () {
    globalThis.avoidDelayedTransition = true;
    setNextRootComponent(type);
  }, [setNextRootComponent, type]);
  return {
    setShimmerType: setShimmerType
  };
});